<app-page-container class="elite-container" [layoutType]="LayoutType.IntegratedTab" [tabConfig]="tabConfig" [title]="title">
</app-page-container>
